/* ============================================================
   SIZE GUIDE POPUP — assets/size-guide-popup.js
   Agregar en theme.liquid antes de </body>:
     <script src="{{ 'size-guide-popup.js' | asset_url }}" defer></script>
   ============================================================ */

function openSizeGuide(productId) {
  const modal = document.getElementById('size-guide-modal-' + productId);
  if (!modal) return;
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';

  // Enfocar el modal para accesibilidad
  const firstBtn = modal.querySelector('button');
  if (firstBtn) firstBtn.focus();
}

function closeSizeGuide(productId) {
  const modal = document.getElementById('size-guide-modal-' + productId);
  if (!modal) return;
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

function handleSizeGuideOverlay(event, productId) {
  // Cerrar si hace clic en el fondo oscuro
  if (event.target === event.currentTarget) {
    closeSizeGuide(productId);
  }
}

function switchSizeGuideTab(btn) {
  const tabsContainer = btn.closest('.size-guide-tabs');
  const modal = btn.closest('.size-guide-modal');
  if (!tabsContainer || !modal) return;

  // Desactivar todos los tabs
  tabsContainer.querySelectorAll('.size-guide-tab').forEach(function(t) {
    t.classList.remove('is-active');
    t.setAttribute('aria-selected', 'false');
  });

  // Ocultar todos los panels
  modal.querySelectorAll('.size-guide-panel').forEach(function(p) {
    p.classList.add('is-hidden');
  });

  // Activar tab seleccionado
  btn.classList.add('is-active');
  btn.setAttribute('aria-selected', 'true');

  const targetId = btn.getAttribute('data-tab');
  const panel = document.getElementById(targetId);
  if (panel) panel.classList.remove('is-hidden');
}

// Cerrar con tecla Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.size-guide-overlay').forEach(function(modal) {
      if (modal.style.display !== 'none') {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }
});
